import { SearchIcon } from '@fabric-app/icons/icons';
import { useSearchOverlay } from '@fabric-app/business/search/hooks/useSearchOverlay';
import { Button } from '@fabric-app/ui/components/Button';

export const GlobalSearchIconButton: React.FC<{ searchType: 'global' | 'location' }> = ({
  searchType,
}) => {
  const { openOverlay } = useSearchOverlay();

  return (
    <Button
      variant="icon"
      shape="square"
      onClick={() => {
        openOverlay(searchType);
      }}
    >
      <SearchIcon style={{ width: 24, height: 24 }} />
    </Button>
  );
};
